import React from 'react';
import { m } from 'framer-motion';
import { PrimaryButton } from '../ui/PrimaryButton';
import { SectionTag } from '../ui/SectionTag';
import { scrollToId } from '../../utils/scroll';
import { forYouPoints } from '../../data/forYou';
export function ForYou() {
  return <section className="bg-white py-14 sm:py-16" data-id="element-79" data-mp="2t9r3qaygt0en">
      <div className="mx-auto max-w-3xl px-6 text-center sm:px-8" data-id="element-80" data-mp="2taizpmvz505g">
        <SectionTag icon="👀" data-id="element-81" data-mp="3gyshmdq2h3rb">Esto es para ti si…</SectionTag>
        <h2 className="mt-5 font-heading text-[28px] font-bold uppercase text-marino sm:text-[36px]" data-id="element-82" data-mp="3gx7nuqbktoui">
          ¿Te suena alguna de estas escenas?
        </h2>
        <p className="mt-4 text-base leading-relaxed text-gris-texto sm:text-lg" data-id="element-83" data-mp="3702zcju9dhaj">
          Si te identificas con 2 o más, Balonmano Pro 360 fue diseñado exactamente para ti.
        </p>
      </div>

      <div className="mx-auto mt-10 grid max-w-6xl gap-5 px-6 sm:grid-cols-2 sm:px-8 lg:grid-cols-3" data-id="element-84" data-mp="1vkxv3behbaot">
        {forYouPoints.map((point, i) => <m.div key={point.n} initial={{
        opacity: 0,
        y: 14
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.4,
        delay: i % 3 * 0.08
      }} className={`rounded-2xl border-l-4 p-6 ${point.bgClass} ${point.borderClass}`} data-id="element-85" data-mp="20ipl1zvkcmqd" data-mpi={i}>
            <div className="flex items-center justify-between" data-id="element-86" data-mp="3u7lrkwnzl9jm">
              <span className="font-heading text-lg font-bold text-marino" data-id="element-87" data-mp="c30n0krptxwx">{point.n}</span>
              <span className="text-2xl" aria-hidden="true" data-id="element-88" data-mp="c0nz7qza0tby">
                {point.emoji}
              </span>
            </div>
            <p className="mt-2 font-heading text-xs font-semibold uppercase tracking-wide text-gris-muted" data-id="element-89" data-mp="ltd8qgb9nx4n">
              {point.tag}
            </p>
            <h3 className="mt-2 font-heading text-base font-semibold leading-snug text-marino" data-id="element-90" data-mp="guiln269nmeq">{point.title}</h3>
            <p className="mt-2 text-[15px] leading-relaxed text-gris-texto" data-id="element-91" data-mp="von7mv6dboe7">{point.text}</p>
          </m.div>)}
      </div>

      <div className="mx-auto mt-10 max-w-2xl px-6 text-center sm:px-8" data-id="element-92" data-mp="xvmtuiuxo7ht">
        <p className="text-base leading-relaxed text-marino sm:text-lg" data-id="element-93" data-mp="12u7jxpgh1asj">
          Entrena con la seguridad de quien llega a la pista sabiendo exactamente qué quiere trabajar, cómo
          corregirlo y cómo conectarlo con el partido del sábado.
        </p>
        <div className="mt-6 flex justify-center" data-id="element-94" data-mp="1cllq2g2xh8un">
          <PrimaryButton onClick={() => scrollToId('oferta-base')} data-id="element-95" data-mp="1hjds42xaebck">Quiero Balonmano Pro 360</PrimaryButton>
        </div>
      </div>
    </section>;
}